import React from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface IArrowRight{
  color?: string
}
export default function ArrowRight({color = defaultGrey}: IArrowRight):  any {
  return (
    <Svg
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        {d: "M10 17l5-5-5-5v10z", fill: color},
        {d: "M0 24V0h24v24H0z", fill: "none"}
      ]}
    />
  )
}